import React, { useState, useEffect, useRef } from 'react'
import { Modal, Input, Button, message } from 'antd'
import identityConfirmIcon from '../../../images/credit/identity-confirm-icon.svg?url'
import './ConfirmIdentityModal.scss'

interface ConfirmIdentityModalProps {
  visible: boolean
  maskedName: string
  phone: string
  onConfirm: (username: string) => void
  onCancel: () => void
  loading?: boolean
  hasError?: boolean // 是否有名字校验失败的错误
  onErrorDismiss?: () => void // 清除错误状态的回调
}

/**
 * 确认被查询人身份弹窗
 */
const ConfirmIdentityModal: React.FC<ConfirmIdentityModalProps> = ({
  visible,
  maskedName,
  phone,
  onConfirm,
  onCancel,
  loading = false,
  hasError = false,
  onErrorDismiss
}) => {
  const [username, setUsername] = useState('')
  const [inputError, setInputError] = useState(false)

  // 当弹窗关闭时重置输入框和错误状态
  useEffect(() => {
    if (!visible) {
      setUsername('')
      setInputError(false)
    }
  }, [visible])

  // 当有外部错误时，设置输入框错误状态并显示错误提示
  useEffect(() => {
    if (hasError && visible) {
      setInputError(true)
      message.error('账号核实失败，请输入正确账号')
    }
  }, [hasError, visible])

  const handleConfirm = () => {
    if (!username.trim()) {
      message.warning('请输入对方完整姓名')
      setInputError(true)
      return
    }
    setInputError(false)
    onConfirm(username.trim())
    setUsername('') // 确认后清空输入框
  }

  const handleCancel = () => {
    setUsername('')
    setInputError(false)
    onCancel()
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUsername(e.target.value)
    // 输入时清除错误状态
    if (inputError) {
      setInputError(false)
      // 清除外部错误状态
      if (onErrorDismiss) {
        onErrorDismiss()
      }
    }
  }

  return (
    <Modal
      title="确认被查询人身份"
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={351}
      centered
      mask={{ closable: false }}
      className="confirm-identity-modal"
    >
      <div className="confirm-identity-content">
        {/* 图标区域 */}
        <div className="identity-icon-wrapper">
          <img
            src={identityConfirmIcon}
            alt="身份确认"
            className="identity-icon"
          />
        </div>

        {/* 说明文字 */}
        <div className="instruction-text">
          为保障隐私，请补全对方账号以继续查询
        </div>

        {/* 脱敏姓名显示 */}
        <div className="masked-name-display">{maskedName}</div>

        {/* 输入框 */}
        <div className="input-wrapper">
          <Input
            placeholder="请输入对方完整账号名"
            value={username}
            onChange={handleInputChange}
            onPressEnter={handleConfirm}
            size="large"
            className={inputError ? 'error' : ''}
          />
        </div>

        {/* 主按钮 */}
        <Button
          type="primary"
          size="large"
          block
          onClick={handleConfirm}
          loading={loading}
          className={`confirm-button ${
            !username.trim() ? 'disabled' : 'enabled'
          }`}
        >
          核实并继续
        </Button>

        {/* 警告文字 */}
        <div className="warning-text">
          核实失败多次将锁定该号码 24 小时查询权限
        </div>
      </div>
    </Modal>
  )
}

export default ConfirmIdentityModal
